import React from "react";
import '../css/stunning.css';

export default function StunningCard() {
    return (
        <div className="cover-stunning">
            <div className="stunning">
                <input type="radio" name="slide" id="c1" checked />
                <label htmlFor="c1" className="custom-stunning">
                    <div class="row">
                        <div class="description">
                            <h4>Beriman & Bertaqwa</h4>
                        </div>
                    </div>
                </label>
                <input type="radio" name="slide" id="c2" />
                <label htmlFor="c2" className="custom-stunning">
                    <div class="row">
                        <div class="description">
                            <h4>Berakhlak
                                Mulia</h4>
                        </div>
                    </div>
                </label>
                <input type="radio" name="slide" id="c3" />
                <label htmlFor="c3" className="custom-stunning">
                    <div class="row">
                        <div class="description">
                            <h4>Berprestasi</h4>
                        </div>
                    </div>
                </label>
            </div>
        </div>
    )
}
